import React from "react";
import { AbsoluteFill, Img, interpolate, spring, staticFile, useCurrentFrame, useVideoConfig } from "remotion";
import { loadFont } from "@remotion/google-fonts/JetBrainsMono";
import { COLOR, LOGO, perFormatScale } from "../../../brand/theme";

const { fontFamily } = loadFont("normal", { weights: ["400", "700", "800"] });

export type SermonTitleProps = {
  pastor: string;
  dateLabel: string;
  title: string;
  subtitle: string;
};

export const SermonTitle: React.FC<SermonTitleProps> = ({ pastor, dateLabel, title, subtitle }) => {
  const frame = useCurrentFrame();
  const { fps, width, height } = useVideoConfig();
  const k = perFormatScale({ w: width, h: height });
  const enter = spring({ frame, fps, config: { damping: 200 } });
  const rise = interpolate(enter, [0, 1], [28, 0]);
  const op = (a: number, b: number) => interpolate(frame, [a, b], [0, 1], { extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ backgroundColor: COLOR.black, fontFamily }}>
      <AbsoluteFill style={{ background: `radial-gradient(circle at 50% 30%, ${COLOR.blue}22 0%, transparent 55%)` }} />

      {/* Header strip — ПАСТОР · знак · ДАТА */}
      <div
        style={{
          position: "absolute", top: 56 * k, left: 64 * k, right: 64 * k,
          display: "flex", alignItems: "center", justifyContent: "space-between",
          opacity: op(0, 18), color: COLOR.white,
          fontSize: 24 * k, fontWeight: 700, letterSpacing: 4 * k,
        }}
      >
        <span>{pastor.toUpperCase()}</span>
        <Img src={staticFile(LOGO.markAsset)} style={{ width: 44 * k, height: 44 * k, filter: LOGO.whiteOnDarkFilter }} />
        <span>{dateLabel.toUpperCase()}</span>
      </div>

      {/* Title */}
      <AbsoluteFill style={{ justifyContent: "center", alignItems: "center", padding: 120 * k }}>
        <div style={{ textAlign: "center", transform: `translateY(${rise}px)` }}>
          <div style={{ opacity: op(10, 30), color: COLOR.white, fontSize: 92 * k, fontWeight: 800, letterSpacing: -1, lineHeight: 1.05 }}>
            {title.toUpperCase()}
          </div>
          <div style={{ opacity: op(22, 42), color: COLOR.blue300, fontSize: 32 * k, fontWeight: 400, letterSpacing: 2 * k, marginTop: 28 * k }}>
            {subtitle}
          </div>
        </div>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
